import type {
  FormattedMemberReferrals,
  MemberReferralsAPIResponse
} from '@library/types/members/memberReferrals';
import {
  getDateTime,
  getFormattedDateTime
} from '@bo-utils/members/memberCommon';

export const transformMemberReferrals = ({
  response
}: {
  response: MemberReferralsAPIResponse;
}): FormattedMemberReferrals => {
  const { data } = response;

  const memberReferrals = data.map((memberReferral) => {
    const {
      attributes: {
        created_at: createdAt,
        deposited,
        deposit_amount: depositAmount,
        deposit_date: depositedDate,
        email,
        name
      },
      id: referralId
    } = memberReferral;

    const { formattedDate: signupDate, formattedTime: signupTime } =
      getFormattedDateTime({
        dateTime: getDateTime({ dateString: createdAt })
      });

    const { formattedDate: depositDate, formattedTime: depositTime } =
      getFormattedDateTime({
        dateTime: getDateTime({ dateString: depositedDate || undefined })
      });

    return {
      depositAmount,
      depositDate,
      deposited,
      depositTime,
      email,
      name,
      referralId,
      signupDate,
      signupTime
    };
  });

  return memberReferrals;
};
